export default "__VITE_ASSET__DEeBp7PD__"